<template>
    <div class="_content">
        <div>
            <div class="main">
                <div class="row-cell">
                    <img :src="tiktokData.goodsImg" alt="" class="pic">
                    <div class="cell-flex">
                        <p class="one-limit cell-name">{{ tiktokData.goodsName }}</p>
                        <p class="cell-price">结算单价<span>￥{{ tiktokData.settlementPrice }}</span></p>
                    </div>
                </div>
                <div class="coupon">
                    <div class="num-time">
                        <p class="num">当前共<span>{{ num }}张</span>可用</p>
                        <p class="time">有效期至{{ tiktokData.exireTime }}</p>
                    </div>
                    <div class="edit-num">
                        <img :src="count <= 1 ? no_minus : minus" alt="" @click="count--">
                        <input v-model="count" type="tel" :max="count" maxlength="2">
                        <img :src="count >= num ? no_add : add" alt="" @click="count >= num ? count = num : count++">
                    </div>
                </div>
            </div>

            <div class="cell-phone">
                <span class="name">手机号码</span>
                <input class="tel-int" v-model="mobile" type="tel" maxlength="11" placeholder="请输入消费者手机号码(非必填)">
            </div>
        </div>

        <div class="footer">
            <p class="desc">共选择<span>{{ count }}</span>张券，核销前请与顾客确认核销券数</p>
            <p class="btn-btn" @click="handlePreverify()">确定核销</p>
        </div>

        <van-popup class="confirm-write-off" v-model="visibleConfirm" round :close-on-popstate="true"
            :close-on-click-overlay='false'>
            <p class="name">确认核销</p>
            <p class="text">请再次确认核销门店与核销券数</p>
            <div class="cell-store">
                <div class="store-info">
                    <span>核销门店：</span>
                    <p class="one-limit">{{ shopName }}</p>
                </div>
                <div class="store-info">
                    <span>核销券数：</span>
                    <p>{{ count }}张</p>
                </div>
            </div>

            <div class="confirm-btn">
                <p class="cancel" @click="visibleConfirm = false">取消核销</p>
                <p class="confirm-button" @click="handleConfirmWriteOff()">确认核销</p>
            </div>
        </van-popup>

        <!-- 抖音核销门店提示 -->
        <van-popup class="tiktoTips" v-model="tiktoStorekVisible" round :close-on-popstate="true"
            :close-on-click-overlay='false'>
            <p class="name">门店提示</p>
            <p class="text">{{ tiktokText }}</p>
            <p class="tit-btn" @click='toBack()'>我知道了</p>
        </van-popup>

    </div>
</template>

<script>
import util from '@/commons/util'
import debounce from 'lodash/debounce'
import config from '@/configs/config'

export default {
    watch: {
        count(val) {
            if (!val) return this.count = 1
            if (val > this.num) return this.count = this.num
        }
    },
    data() {
        return {
            tiktoStorekVisible: false,
            tiktokText: '',
            visibleConfirm: false,
            count: 1,
            mobile: '',
            shopId: tuhu.getParam('shopId') || '',
            shopName: tuhu.getParam('shopName') || '',
            path: tuhu.getParam('path') || '',
            num: 1,
            tiktokData: {},
            minus: 'https://res.xiaokunkeji.cn/image/2023/12/13/4aaaca8b6a7549e9be69f356e4c7a3b2.png',
            no_minus: 'https://res.xiaokunkeji.cn/image/2023/12/13/e67c874239f84bf3b1102e9226aeb0dd.png',
            add: 'https://res.xiaokunkeji.cn/image/2023/12/13/75fb9b8d2d824802a03027ef10683b0f.png',
            no_add: 'https://res.xiaokunkeji.cn/image/2023/12/13/1bc24facb5ec4d7a8f38e681707a22fa.png'
        }
    },

    mounted() {
        this.getTiktokInfo()
    },

    methods: {
        getTiktokInfo() {
            try {
                tuhu.showIndicator()
                tuhu
                    .fetch(`${config.apis.GET_TIKTOY_MERCHANT_PREPARE}?path=${encodeURIComponent(this.path)}&shop=${this.shopId}`)
                    .then((data) => {
                        if (data.code === '200') {
                            tuhu.hideIndicator();

                            this.tiktokData = data.data
                            this.num = data.data.num
                        } else {
                            tuhu.hideIndicator();

                            if (data.code == 4003) {
                                this.tiktoStorekVisible = true
                                this.tiktokText = '您的门店暂未暂未上架该服务，请联系您的商户专员或小鲲车服客服开通！'
                            }
                            else if (data.code == 4004) {
                                this.tiktoStorekVisible = true
                                this.tiktokText = '您的门店已下架该服务无法核销，请联系您的商户专员或小鲲车服客服重新上架！'
                            }
                            else {
                                tuhu.toast(data.message)
                            }
                        }
                    });
            } catch (error) {
                tuhu.hideIndicator();
                console.log('err', error)
                tuhu.toast(error)
            }
        },

 

        handlePreverify() {
            if (this.mobile) {
                if (!util.isPhone(this.mobile)) return tuhu.toast('请输入正确的手机号')
            }
            this.visibleConfirm = true
        },


        handleConfirmWriteOff: debounce(async function () {
            const { poiId, ttokorderId } = this.tiktokData
            tuhu.showIndicator()
            const res = await tuhu.fetch(`${config.apis.GET_TIKTOK_VERIFY}`, {
                method: "post",
                body: JSON.stringify({
                    mobile: this.mobile || '400-176-8848',
                    shopId: this.shopId,
                    poiId: poiId,
                    orderId: ttokorderId,
                    num: this.count
                }),
            })
            if (res.code === '200') {
                this.mobile = ''
                tuhu.hideIndicator();
                tuhu.navigateTo({
                    url: '/pages/tiktok/result',
                    query: {
                        isSucess: 1,
                        shopId: this.shopId,
                        goodsOrderId: res.data.goodsOrderId
                    }
                })
            } else {
                this.mobile = ''
                tuhu.hideIndicator();
                tuhu.navigateTo({
                    url: '/pages/tiktok/result',
                    query: {
                        tips: res.code == '5017' ? res.message : ''
                    }

                })
            }

        }, 500),

        toBack() {
            tuhu.navigateTo({
                url: '/pages/home/index',
            })
        },
    }
}
</script>

<style lang="less" scoped>
._content {
    width: 100%;
    height: 100%;
    background: #F8F9FB;
    padding: .75rem;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}

.main {
    padding: .75rem;
    box-shadow: 0rem 0.1rem 0.5rem 0rem #F8F9FB;
    background: #fff;
    border-radius: .4rem;

    .row-cell {
        display: flex;
        padding-bottom: .75rem;
        border-bottom: 1px dashed #C6C6C6;

        .pic {
            width: 3.5rem;
            height: 3.5rem;
            min-width: 3.5rem;
            margin-right: .75rem;
            border-radius: .4rem;
        }

        .cell-flex {
            display: flex;
            flex-direction: column;
            justify-content: space-around;
            overflow: hidden;

            .cell-name {
                color: #09090A;
                font-size: .8rem;
                font-weight: 600;

            }

            .cell-price {
                color: #333333;
                font-size: .65rem;
                display: flex;
                align-items: center;

                >span {
                    color: #176DF9;
                    font-size: .65rem;
                }
            }
        }
    }

    .coupon {
        margin-top: .75rem;
        display: flex;
        align-items: center;
        justify-content: space-between;

        .num-time {
            .num {
                color: #333333;
                font-size: .65rem;
                line-height: .8rem;

                >span {
                    color: #176DF9;
                }
            }

            .time {
                margin-top: .35rem;
                color: #C6C6C6;
                font-size: .55rem;
                line-height: .7rem;
            }
        }

        .edit-num {
            display: flex;
            align-items: center;

            img {
                width: 1.4rem;
                height: 1.4rem;
                border-radius: .2rem;
            }

            >input {
                width: 2.2rem;
                text-align: center;
                height: 1.4rem;
                color: #09090A;
                font-size: .8rem;
                font-weight: 600;
                font-family: SF Pro Display, SF Pro Display;
            }
        }
    }
}

.cell-phone {
    display: flex;
    height: 2.4rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: #fff;
    border-radius: .4rem;
    box-shadow: 0rem 0.1rem 0.5rem 0rem #F8F9FB;
    margin-top: .5rem;
    padding: 0 .75rem;

    .name {
        color: #333333;
        font-size: .65rem;
        min-width: 5rem;
    }

    .tel-int {
        flex: 1;
        font-size: .7rem;
        color: #122222;
        text-align: right;
        height: 2.4rem;
    }
}

.footer {
    margin-bottom: .75rem;

    .desc {
        font-size: .65rem;
        color: #808080;
        margin-bottom: .6rem;
        text-align: center;

        >span {
            color: #176DF9;
        }
    }

    .btn-btn {
        width: 16.75rem;
        height: 2.2rem;
        background: #176DF9;
        border-radius: 1.1rem 1.1rem 1.1rem 1.1rem;
        line-height: 2.2rem;
        text-align: center;
        color: #fff;
        font-size: 0.85rem;
    }
}

.confirm-write-off {
    width: 85%;
    overflow: hidden;

    .name {
        text-align: center;
        color: #09090A;
        font-size: .8rem;
        font-weight: bold;
        line-height: 1.2rem;
        padding: 1.2rem .75rem .4rem;
    }

    .text {
        color: #333333;
        font-size: .7rem;
        line-height: 1.1rem;
        margin-bottom: .75rem;
        text-align: center;
        padding: 0 .75rem;

    }

    .cell-store {
        background: #F3F8FF;
        border-radius: 0.4rem;
        padding: .75rem 1.5rem .01rem;
        margin: .75rem .75rem 1.2rem;

        .store-info {
            display: flex;
            align-items: center;
            font-size: .7rem;
            margin-bottom: .75rem;

            >span {
                color: #333333;
                white-space: nowrap;
            }

            >p {
                color: #09090A;
            }
        }
    }

    .confirm-btn {
        display: flex;
        align-items: center;
        height: 2.7rem;
        border-top: 1px solid #ECEDEE;
        overflow: hidden;
        justify-content: center;

        >p {
            width: 50%;
            height: 2.7rem;
            line-height: 2.7rem;
            text-align: center;
            font-size: .8rem;
        }

        .cancel {
            color: #262F42;
            border-right: 1px solid #ECEDEE;
        }

        .confirm-button {
            color: #176DF9;
            text-align: center;
        }
    }
}

.tiktoTips {
    width: 85%;
    overflow: hidden;

    .name {
        text-align: center;
        color: #09090A;
        font-size: .8rem;
        font-weight: bold;
        line-height: 1.2rem;
        margin-bottom: 1.2rem;
        padding: 1.2rem 1rem 0;
    }

    .text {
        color: #333333;
        font-size: .7rem;
        line-height: 1.1rem;
        margin-bottom: 1.2rem;
        padding: 0 1rem;

    }

    .tit-btn {
        height: 2.7rem;
        text-align: center;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #176DF9;
        font-size: .8rem;
        border-top: 1px solid #D4D6D9;
    }
}
</style>


// WEBPACK FOOTER //
// src/pages/record/verify.vue